(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDeleteController',CustomGroupTypeAttributeDeleteController);

    CustomGroupTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDeleteController($uibModalInstance, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomGroupTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
